import React from 'react';
import PropTypes from 'prop-types';

const SelectedPropCodes = ({ selectedPropCodes }) => {
  const getTitle = item => {
    return `${item.displayMemriUser}`;
  };
  return (
    <div className="PropCode-Content-Selected">
      <label className="PropCode-Content-Selected-label">
        {' '}
        Selected MEMRI User(s)
      </label>
      <div className="PropCode-Content-Selected-box">
        <div className="propcode-list">
          <ul>
            {selectedPropCodes.map(item => {
              return (
                <li key={Math.random()}>
                  <label
                    htmlFor={item.id}
                    title={getTitle(item)}
                    className="selected"
                  >
                    {item.displayMemriUser}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
SelectedPropCodes.propTypes = {
  selectedPropCodes: PropTypes.arrayOf(PropTypes.object),
};
export default React.memo(SelectedPropCodes);
